import { ref } from "vue";

// hooked used to set alert messages in UI
export default function useAlert() {
  const message = ref("");
  const messageStyleType = ref("success");
  const messageContainsHtml = ref(false);

  function setMessage(msg, type, containsHtml) {
    message.value = msg;
    messageStyleType.value = type;
    messageContainsHtml.value = containsHtml;
  }

  return {
    message,
    messageStyleType,
    messageContainsHtml,
    setMessage,
  };
}
